import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import makeStyles from '@material-ui/core/styles/makeStyles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';

const useStyles = makeStyles(() => ({
   root: {
      boxShadow: 'none'
   }
}));
/**
 * Barra superior estatica para pantalla principal, el contenido envuelto por este componente aparecera como hijo del componente [Toolbar](https://material-ui.com/api/toolbar/#toolbar-api).
 *
 * Cualquier otra propiedad no especificada en la documentacion sera reenviada al componente [AppBar](https://material-ui.com/api/app-bar/).
 */
const Topbar = React.forwardRef(function Topbar({className, children, ...rest}, ref) {
   const classes = useStyles();

   return (
      <AppBar
         ref={ref}
         {...rest}
         className={clsx(classes.root, className)}
         color="primary"
         position="fixed"
      >
         <Toolbar>{children}</Toolbar>
      </AppBar>
   );
});

Topbar.propTypes = {
   className: PropTypes.string
};

export default Topbar;
